module.exports = error => {
    if (error.response) {
        console.log(error.response)
        switch (error.response.status) {
            case 524:
                return '524 Cloudflare Gateway Time-out'
            break;

            case 504:
                return '504 LMS Gateway Time-out'
            break;

            case 502:
                return '502 Bad Gateway'
            break;

            case 401:
                return '401 Authorization not exist'
            break;

            default:
                return error.response.status + ' ' + error.response.statusText
        }
    } else {
        if (typeof error == 'string') {
            return error
        }
        return 'Network Abnormality'
    }
}
